export enum AppointmentStatuses {
    Confirmed = "CONFIRMED",
    Declined = "DECLINED",
    Scheduled = "SCHEDULED",
    Rescheduled = "REQUEST_RESCHEDULE" ,
    Unconfirmed = "UNCONFIRMED",
}